export default "__VITE_ASSET__CRqS8Few__"